export const filterCustomTemplates = (templates, doctorId) => {
  return templates.filter(
    ({ isPrivate, creatorDoctorId, _deleted }) => !_deleted && (isPrivate ? creatorDoctorId === doctorId : true)
  )
}
